"use strict";

exports.__esModule = true;
exports.default = void 0;

var _uiPreview = _interopRequireDefault(require("./uiPreview"));

var _uiSchema = _interopRequireDefault(require("./details/uiSchema"));

var _uiSchema2 = _interopRequireDefault(require("./basis/uiSchema"));

var _uiSchema3 = _interopRequireDefault(require("../attachments/uiSchema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = {
  "ui:field": "pageEditor",
  "ui:editable": true,
  "ui:preview": _uiPreview.default,
  "ui:fieldset": ["content"],
  "content": {
    "ui:field": "pageContent",
    "ui:fieldset": ["basis", "details", "attachments"],
    "basis": _extends({}, _uiSchema2.default, {
      "ui:step": "1/3",
      "ui:nextStep": "2/3",
      "ui:nextId": "root_content_details"
    }),
    "details": _extends({}, _uiSchema.default, {
      "ui:step": "2/3",
      "ui:nextStep": "3/3",
      "ui:nextId": "root_content_attachments"
    }),
    "attachments": _extends({}, _uiSchema3.default, {
      "ui:step": "3/3",
      "ui:nextAction": "save"
    })
  }
};
exports.default = _default;
module.exports = exports.default;